'use strict';

/* jshint -W098 */
angular.module('mean.builders').controller('BuildersBidController', ['$scope', 'Global', 'Bids', '$filter', '$sce', 'toaster', 'NotifyService', 'BidRequestReview', '$http', 'CompanyFactors', 'Projects', 'ProjectBids', '$location', 'ProjectJobs', 'BidOldReview', 'MeanUser', 'tradeCodeService', 'taskTotalsService', 'userService', 'BidRequestEdit', 'Builders', 'BidBuilderReview', 'BidWizardEdit', 'ngDialog', 'TradeBids', 'optionSaveService',
  function($scope, Global, Bids, $filter, $sce, toaster, NotifyService, BidRequestReview, $http, CompanyFactors, Projects, ProjectBids, $location, ProjectJobs, BidOldReview, MeanUser, tradeCodeService, taskTotalsService, userService, BidRequestEdit, Builders, BidBuilderReview, BidWizardEdit, ngDialog, TradeBids, optionSaveService) {
    $scope.global = Global;
    $scope.package = {
      name: 'bids'
    };

    if(!MeanUser.user._id) {
        $location.path('/');
        return;
    }

    $scope.user = MeanUser.user;
    $scope.is_admin = userService.isAdmin($scope.user);
    $scope.is_builder = true;
    $scope.showPlanDetails = -1;
    $scope.main_account_id = null;

    $scope.pop = function() {
        toaster.pop('success', 'title', 'text');
    };

    $scope.editId = 1;

    userService.getMainAccountId($scope.user.username).then(function(result) {
        $scope.main_account_id = result;
        Builders.query({'builder': result}, function(builders) {
            if(builders.length !== 1) return;

            $scope.builder_info = builders[0];

            Bids.query({'builder_id': builders[0]._id}, function(bids) {
                $scope.new_bids = $filter('filter')(bids, { bid_status: 'new' });
                //$scope.submitted_bids = $filter('filter')(bids, { bid_status: 'submitted' });
                $scope.review_bids = $filter('filter')(bids, { bid_status: 'review' }, true);
                $scope.builder_bids = $filter('filter')(bids, { bid_status: 'builder_review' } && { bid_status: 'submitted' }, true);
                $scope.project_bids = $filter('filter')(bids, { bid_status: 'project' });

                // for(var i=0; i<$scope.project_bids.length; i++) {
                //     for(var j=$scope.project_bids[i].bidding_trades.length-1; j>=0; j--) {
                //         if(!$scope.project_bids[i].bidding_trades[j].accepted)
                //           $scope.project_bids[i].bidding_trades.splice(j, 1)
                //     }
                // }

                // for(var i=0; i<$scope.builder_bids.length; i++) {
                //     if($scope.builder_bids[i].in_bidder_revision) {
                //         for(var j=$scope.builder_bids[i].bidding_trades.length-1; j>=0; j--) {
                //             if(!$scope.builder_bids[i].bidding_trades[j].accepted)
                //               $scope.builder_bids[i].bidding_trades.splice(j, 1)
                //         }
                //     }
                // }

                for(var i=0; i<$scope.builder_bids.length; i++){
                    var bid= $scope.builder_bids[i];
                    var amount = $filter('filter')(bid.bidding_trades, {'submitted': 'true'}, true);
                    bid.bid_number_completed = amount.length;
                }

                for(var i=0; i<$scope.builder_bids.length; i++){
                    var bid= $scope.builder_bids[i];

                    if(bid.project_plan.single.length) {
                        bid.number_of_units = 0;
                        for(var j=0; j<bid.project_plan.single.length; j++) {
                            var plan_item = bid.project_plan.single[j];
                            if(plan_item.quantity)
                              bid.number_of_units += plan_item.quantity;
                        }
                    }
                }

                //check if already accepted.  if so, remove trades
                //not accepted and then add in for each revision
                // if($scope.bid.bid_status === 'project' ||
                //     $scope.bid.in_bidder_revision) {
                //     for(var i=$scope.bid.bidding_trades.length-1; i>=0; i--) {
                //         if(!$scope.bid.bidding_trades[i].accepted)
                //           $scope.bid.bidding_trades.splice(i, 1)
                //     }
                // }
            });
        });
    });

    $scope.editRequest = function() {
        console.log($scope);
        var bid = $filter('filter')($scope.submitted_bids, {'_id': $scope.details_bid_id}, true);

        if(bid.length === 1) {
            BidRequestEdit.set(bid[0]);
        } else {
            toaster.pop('error', 'Trade Bid Requests', 'There was a problem getting the bid details.  Contact Admin.');
        }
    };

    // $scope.addBid = function() {
    //     if (!$scope.bid_name) $scope.bid_name = [];

    //     var bid = new Bids({
    //         bid_name: $scope.bid_name,
    //         builder_id: $scope.builder_info._id,
    //         bid_status: 'new'
    //     });

    //     bid.$save(function(response) {
    //         $scope.new_bids.push(response);

    //         var data = $scope.new_bids;
    //         $scope.newBidTableParams.total(data.length);
    //         $scope.newBidTableParams.reload();
    //     });
    // };

    $scope.goToWizard = function(item) {
        BidWizardEdit.set(item);
        $location.path('/builder/admin/wizard');
    };

    $scope.addBid = function() {
        if (!this.bid_name) this.bid_name = [];

        var bid = new Bids({
            bid_name: this.bid_name,
            bid_status: 'new',
            builder_id: $scope.builder_info._id
        });

        bid.$save(function(response) {
            $scope.new_bids.push(response);

            BidWizardEdit.set(response);
            $location.path('/builder/admin/wizard');
        });
    };

    $scope.remove = function(bid) {
        if(!$scope.is_admin) {
            alert('You must have admin rights to remove a bid.');
            return;
        }

        for (var i in $scope.new_bids) {
            if ($scope.new_bids[i] === bid) {
                $scope.new_bids.splice(i, 1);
            }
        }

        bid.$remove();

        var data = $scope.new_bids;
        $scope.newBidTableParams.total(data.length);
        $scope.newBidTableParams.reload();
    };

    $scope.removeTradeBid = function(index) {
        console.log(index);
        console.log($scope);

        this.builder_bids[$scope.current_review_bid].bidding_trades.splice(index, 1);

        //probably should add code to check the notification list and
        //remove for the trade if found.

        this.builder_bids[$scope.current_review_bid].$update(function(success) {
            if(success.project_plan.single.length) {
                success.number_of_units = 0;
                for(var j=0; j<success.project_plan.single.length; j++) {
                    var plan_item = success.project_plan.single[j];
                    if(plan_item.quantity)
                      success.number_of_units += plan_item.quantity;
                }
            }

            var amount = $filter('filter')(success.bidding_trades, {'submitted': 'true'}, true);
            success.bid_number_completed = amount.length;
        });
    };

    $scope.removeTradeBidOperation = function(id) {
        ngDialog.openConfirm({
            template:
                '<h2>Delete Bid Requests</h2>' +
                '<p>This operation will delete the bid request from the system</p>' +
                '<p>Are you sure you want to delete this bid? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.removeTradeBid(id);
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.removeBid = function(id) {
        if(!$scope.is_admin) {
            alert('You must have admin rights to remove a bid.');
            return;
        }
        //new_bids already have a delete function.  This will be for
        //submitted and review bids.  The delete will be coming from
        //the associated lists modal.

        for (var i in $scope.submitted_bids) {
            if ($scope.submitted_bids[i]._id === id) {
                var bid = $scope.submitted_bids.splice(i, 1);
                if(bid.length === 1) {
                    bid[0].$remove();
                } else {
                    alert('More than one bid returned for deletion.  Contact Admin.');
                }
                return;
            }
        }
        for (var i in $scope.review_bids) {
            if ($scope.review_bids[i]._id === id) {
                var bid = $scope.review_bids.splice(i, 1)
                if(bid.length === 1) {
                    bid[0].$remove();
                } else {
                    alert('More than one bid returned for deletion.  Contact Admin.');
                }
                return;
            }
        }
    };

    $scope.deleteOperation = function(id) {
        ngDialog.openConfirm({
            template:
                '<h2>Delete Bid Data</h2>' +
                '<p>This operation will delete all bid data from the system</p>' +
                '<p>Are you sure you want to delete this bid? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.deleteBid(id);
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    $scope.deleteBid = function(id) {
        console.log('in deleteBid function with id ' + id);
        if(!$scope.is_admin) {
            alert('You must have admin rights to delete a bid.');
            return;
        }

        for (var i in $scope.project_bids) {
            if ($scope.project_bids[i]._id === id) {
                var bid = $scope.project_bids.splice(i, 1);
                if(bid.length === 1) {
                    bid[0].$remove();
                } else {
                    alert('More than one bid returned for deletion.  Contact Admin.');
                }
                return;
            }
        }
    };

    $scope.padDigits = function(number, digits) {
        return Array(Math.max(digits - String(number).length + 1, 0)).join(0) + number;
    }

    $scope.acceptBid = function() {
        var bid = $scope.builder_bids[$scope.current_review_bid];

        var bid_trades = [];
        var plan_codes = [];
        var tasks = [];
        var plans = [];

        var menu = bid.project_plan;

        _.each(bid.plan_codes, function(plan_code) {
            $scope.bid_menu.push({
                item: plan_code.code
            });
        });

        //this will need to change
        //CompanyFactors.query({}, function(company_factors) {
            for(var i=0; i<bid.bidding_trades.length; i++) {
                //forEach(function(bidder, idx) {
                //var trade = $filter('filter')(company_factors, {trade_name: bidder.trade})[0];
                bid_trades.push({
                    name: bid.bidding_trades[i].trade,
                    manager: {
                        name: bid.bidding_trades[i].name,
                        username: bid.bidding_trades[i].username,
                        phone: bid.bidding_trades[i].phone,
                        email: bid.bidding_trades[i].email
                    },
                    supplier: bid.bidding_trades[i].supplier,
                    equipment_supplier: bid.bidding_trades[i].equipment_supplier,
                    inclusions: bid.bidding_trades[i].inclusions,
                    exclusions: bid.bidding_trades[i].exclusions,
                    company_factors: bid.bidding_trades[i].costs
                });
            }

            tasks = [];
            var days_off = 0;
            bid.task_list.forEach(function(task, ii) {
                var subs = [];
                task.subtasks.forEach(function(sub) {
                    subs.push({
                        name: sub.name
                    });
                });

                tasks.push({
                    name: task.name,
                    order: task._id,
                    task: task.task,
                    hours: 8.0,
                    days: 1.0,
                    days_offset: days_off,
                    trade: task.trade,
                    subtasks: subs
                });

                days_off += 1;
            });

            plans.push({
                item: 'Standard',
                task_list: tasks
            });

            ProjectJobs.query({'company_code': $scope.builder_info.company_code, 'trade_code': '00'}, function(jobs) {
                var new_job_code = '';

                if(jobs.length === 1) {
                    new_job_code = $scope.padDigits(jobs[0].current_value, 4);
                    jobs[0].current_value = jobs[0].current_value + 1;
                    if(jobs[0].current_value === 10000) jobs[0].current_value = 1;
                    jobs[0].$update();
                } else if(jobs.length === 0) {
                    var new_job = new ProjectJobs({
                        company_code: $scope.builder_info.company_code,
                        trade_code: '00',
                        current_value: 2
                    });
                    new_job_code = $scope.padDigits(1, 4);
                    new_job.$save();
                } else if(jobs.length > 1) {
                    alert('More than one contractor/division combination came back.  Call admin.');
                    return;
                }

                var project = new Projects({
                    name: bid.project_name,
                    projectBidId: bid._id,
                    job_code: new_job_code,
                    contact: {
                        name: bid.purchasing_agent_name,
                        address_one: bid.project_address,
                        address_two: '',
                        city: bid.project_city,
                        state: bid.project_state,
                        zip: bid.project_zip,
                        timezone: bid.project_timezone,
                        email: bid.purchasing_agent_email,
                        phone: bid.purchasing_agent_phone_number
                    },
                    builder: {
                        name: bid.builder_name,
                        division: bid.builder_division,
                        address_one: bid.builder_address_one,
                        address_two: bid.builder_address_two,
                        city: bid.builder_city,
                        state: bid.builder_state,
                        zip: bid.builder_zip,
                        email: bid.builder_email,
                        phone: bid.builder_phone_number
                    },
                    mtc: {
                        name: bid.mtc_name,
                        code: bid.mtc_code,
                        division: bid.mtc_division,
                        president_name: bid.mtc_president_name,
                        president_phone_number: bid.mtc_president_phone_number,
                        president_email: bid.mtc_president_email,
                        division_manager_name: bid.mtc_division_manager_name,
                        division_manager_phone_number: bid.mtc_division_manager_phone_number,
                        division_manager_email: bid.mtc_division_manager_email
                    },
                    project_type: bid.project_type,
                    projectType: bid.projectType,
                    geoLocation: bid.geoLocation,
                    plan_codes: plan_codes,
                    trades: bid_trades,
                    plan: plans,
                    mainAccountId: $scope.main_account_id
                });

                project.$save(function(saved) {

                    console.log('project save came back with ' + saved._id);
                    if(optionSaveService.updateProjectIdFromBidId(bid._id, saved._id)) {
                        return;
                    }

                    bid.bidding_trades.forEach(function(bidder, idx) {
                        var trade = $filter('filter')(company_factors, {trade_name: bidder.trade}, true)[0];

                        $scope.company_factors = trade;
                        saved.plan_codes.forEach(function(plan) {
                            var tasks = $filter('filter')(bidder.bid, {plan_code: plan.item}, true);

                            tasks.forEach(function(task, ii) {
                                var cp_task = $filter('filter')(bid.task_list, {_id: task.task_id}, true);
                                if(cp_task.length !== 1)
                                    alert('There is an issue getting the task');

                                task.subtasks.forEach(function(sub, ij) {
                                    sub.crew_rate = cp_task[0].subtasks[ij].crew_rate;
                                    sub.piece_per_hour_rate = cp_task[0].subtasks[ij].piece_per_hour_rate;
                                    sub.piece_rate = cp_task[0].subtasks[ij].piece_rate;
                                    sub.unit = cp_task[0].subtasks[ij].unit;
                                });

                                task.materials.forEach(function(mat, ij) {
                                    mat.supplier = cp_task[0].materials[ij].supplier;
                                });

                                task.equipment.forEach(function(eq, ij) {
                                    eq.supplier = cp_task[0].equipment[ij].supplier;
                                });
                            });
                            //before applying the calcs, get the piece rates and stuff from the task list
                            $scope.applayCalculations(tasks);

                            //now we have all the calculations for a given plan, so lets save them
                            //off into the projectBids database
                            tasks.forEach(function(task) {
                                var cp_task = $filter('filter')(bid.task_list, {_id: task.task_id}, true)[0];
                                if(!cp_task) {
                                    alert('Could not get the task from the bid.task_list.  Call admin.');
                                    return;
                                }
                                var sub_arr = [];
                                var mat_arr = [];
                                var eq_arr = [];

                                //build the subtask array
                                task.subtasks.forEach(function(sub, ii) {
                                    sub_arr.push({
                                        task_id: sub.task_id,
                                        name: cp_task.subtasks[ii].name,
                                        crew_rate: sub.crew_rate,
                                        current_net_pay: sub.current_net_pay,
                                        employee_benefits: sub.employee_benefits,
                                        piece_per_hour_rate: sub.piece_per_hour_rate,
                                        piece_rate: sub.piece_rate,
                                        unit: sub.unit,
                                        bid_hours: sub.bid_hours,
                                        hours_allowed: sub.hours_allowed,
                                        training_and_education: sub.training_and_education,
                                        quantity: sub.quantity,
                                        labor_total: sub.labor,
                                        bid_mark_up: sub.bid_mark_up,
                                        general_liability: sub.general_liability,
                                        material_total: sub.material_total,
                                        equipment_total: sub.equipment_total,
                                        total: sub.total,
                                        work_comp: sub.work_comp
                                    });
                                });

                                task.materials.forEach(function(mat, ii) {
                                    mat_arr.push({
                                        name: cp_task.materials[ii].name,
                                        material_id: mat.material_id,
                                        supplier: mat.supplier,
                                        quantity: mat.quantity,
                                        price_per_order: mat.price_per_order,
                                        piece_per_size: mat.piece_per_size,
                                        delivery_price: mat.delivery_price,
                                        isInventory: mat.isInventory || false,
                                        delivery_offset: cp_task.materials[ii].delivery_offset,
                                        description: cp_task.materials[ii].description,
                                        note: cp_task.materials[ii].note,
                                        unit: cp_task.materials[ii].unit
                                    });
                                });

                                task.equipment.forEach(function(eq, ii) {
                                    eq_arr.push({
                                        name: cp_task.equipment[ii].name,
                                        equipment_id: eq.equipment_id,
                                        supplier: eq.supplier,
                                        quantity: eq.quantity,
                                        price_per_order: eq.price_per_order,
                                        piece_per_size: eq.piece_per_size,
                                        delivery_price: eq.delivery_price,
                                        delivery_offset: cp_task.equipment[ii].delivery_offset,
                                        description: cp_task.equipment[ii].description,
                                        note: cp_task.equipment[ii].note,
                                        unit: cp_task.equipment[ii].unit
                                    });
                                });

                                var override = $filter('filter')(bid.overrides, {
                                    'plan_code': task.plan_code, 'enabled': true }, true);

                                var offset_total = 0;
                                var mark_up = task.bid_mark_up
                                //only adjust override total on the first task
                                if(override.length === 1 && itr === 0) {
                                    offset_total = override[0].amount - override[0].original_amount;
                                    mark_up = override[0].amount;
                                }

                                var extra_liability = $filter('filter')(bid.extra_liability, {
                                    'plan_code': task.plan_code, 'enabled': true }, true);

                                if(extra_liability.length === 1 && itr === 0) {
                                    task.bid_general_liability += extra_liability[0].amount;
                                    task.total += extra_liability[0].amount;
                                }

                                var proBid = new ProjectBids({
                                    task_name: cp_task.name,
                                    trade: $scope.getTradeString(cp_task.trade),
                                    project_id: saved._id,
                                    task_code: cp_task.trade + cp_task.task,
                                    plan_code: task.plan_code,
                                    days: 1.0,
                                    hours: 8.0,
                                    days_offset: task.task_id - 1,
                                    task_id: task.task_id,
                                    totals: {  //task totals computed during bid phase (during accepting)
                                        total: task.total + offset_total,
                                        labor: task.total_labor,
                                        materials: task.total_materials,
                                        materials_subtotal: task.materials_subtotal,
                                        materials_dev_subtotal: task.materials_dev_subtotal,
                                        equipment: task.total_equipment,
                                        equipment_subtotal: task.equipment_subtotal,
                                        equipment_dev_subtotal: task.equipment_dev_subtotal,
                                        current_net_pay: task.total_current_net_pay,
                                        general_liability: task.bid_general_liability,
                                        mark_up: mark_up,
                                        work_comp: task.work_comp,
                                        hours_allowed: task.total_hours_allowed
                                    },
                                    subtasks: sub_arr,
                                    materials: mat_arr,
                                    equipment: eq_arr
                                });

                                proBid.$save();
                            });
                        })

                    });

                    bid.project_id = saved._id;
                    bid.bid_status = 'project';
                    bid.$update();
                });
            });
        //});

        $location.path('project admin');
    };

    $scope.viewBidDetails = function(index){
        //here we can use the $scope.submitted_bids[index].bidding_trades to
        //get details on who is done and who is not.
        $scope.details_bid_id = $scope.submitted_bids[index]._id;
        $scope.details_bid_name = $scope.submitted_bids[index].bid_name;
        $scope.details_bidding_trades = $scope.submitted_bids[index].bidding_trades;
        $scope.details_bid_in_revision = $scope.submitted_bids[index].in_bidder_revision;
        $scope.details_return_date = $scope.submitted_bids[index].bid_date_requested;
        var today = moment(new Date());
        var requested = moment(new Date($scope.submitted_bids[index].bid_date_requested));

        console.log('today: ' + today.format('DD-MM-YYYY') +
            ', requested: ' + requested.format('DD-MM-YYYY') +
            ', difference: ' + Math.floor(moment.duration(requested.diff(today)).asDays()));

        $scope.details_days_remaining = Math.floor(moment.duration(requested.diff(today)).asDays());
    };

    $scope.viewBidReviewDetails = function(index){
        //here we can use the $scope.submitted_bids[index].bidding_trades to
        //get details on who is done and who is not.
        $scope.details_bid_id = $scope.review_bids[index]._id;
        $scope.details_bid_name = $scope.review_bids[index].bid_name;
        $scope.details_bidding_trades = $scope.review_bids[index].bidding_trades;
        $scope.details_bid_in_revision = $scope.review_bids[index].in_bidder_revision;
        //set the index so we know which bid is getting selected
        $scope.current_review_bid = index;
    };

    $scope.viewBidBuilderDetails = function(index){
        //here we can use the $scope.submitted_bids[index].bidding_trades to
        //get details on who is done and who is not.
        $scope.details_bid_id = $scope.builder_bids[index]._id;
        $scope.details_bid_name = $scope.builder_bids[index].bid_name;
        $scope.details_bidding_trades = $scope.builder_bids[index].bidding_trades;
        $scope.details_bid_in_revision = $scope.builder_bids[index].in_bidder_revision;
        //set the index so we know which bid is getting selected
        $scope.current_review_bid = index;
    };

    $scope.viewBidProjectDetails = function(index){
        //here we can use the $scope.submitted_bids[index].bidding_trades to
        //get details on who is done and who is not.
        $scope.details_bid_id = $scope.project_bids[index]._id;
        $scope.details_bid_name = $scope.project_bids[index].bid_name;
        $scope.details_bidding_trades = $scope.project_bids[index].bidding_trades;
        $scope.details_bid_in_revision = $scope.project_bids[index].in_bidder_revision;
        //set the index so we know which bid is getting selected
        $scope.current_review_bid = index;
    };

    $scope.reviewBid = function(bid) {
        //select the bid and pass it into set with the bid index to be reviewed.
        BidRequestReview.set($scope.builder_bids[$scope.current_review_bid], bid);
        $location.path('/request/review');
    };

    $scope.reviewBids = function(bid) {
        BidBuilderReview.set($scope.builder_bids[$scope.current_review_bid]);
    };

    $scope.submitToBuilder = function() {
        var bid = $scope.review_bids[$scope.current_review_bid];

        //update bid status and send to database
        bid.bid_status = 'builder_review';
        bid.$update();

        //move bid from review_bids to builder_bids
        $scope.builder_bids.push(bid);
        $scope.review_bids.splice($scope.current_review_bid, 1);

        var data = ({
            builderName: bid.builder_name,
            builderEmail: bid.builder_email,
            builderSubject: bid.project_name + ' is ready for your review.',
            builderMessage: bid.builder_name + ', please log in to http://ec2-54-183-70-119.us-west-1.compute.amazonaws.com/ and review ' + bid.bid_name + '.  <br>Please contact Brandon Wilson after you\'ve had a chance to review to set up a start date for your new project.'
        });

        $http.post('/api/sendBuilderEmail', data).
          success(function(data, status, headers, config) {
            console.log('Message to builder was successfully sent');
          }).
          error(function(data, status, headers, config) {
            console.log('There was an error with the message');
        });
    };

    $scope.addTradeToBid = function() {
        console.log('in the addTradeToBid function' + $scope);
        BidWizardEdit.set($scope.builder_bids[$scope.current_review_bid]);
        $location.path('builder/add/bidder');
    };

    $scope.rejectBid = function() {
        console.log('in the rejectBid function' + $scope);
        //$scope.builder_bids
        //$scope.bid.bidding_trades[$scope.bid.review_trade_index].submitted = 'false';
        //$scope.bid.bid_status = 'submitted';
        //$scope.bid.$update();
        //$location.path('requests');
    };

    $scope.returnedEmail = function() {
        console.log('email has been sent');
    };

    $scope.getProgress = function(bid) {
        var today = new Date();
        var requested = new Date(bid.bid_date_requested);
        requested.setDate(requested.getDate() - today.getDate());
        var diff = requested.getDate();
        if(diff < 1) {
            bid.progress_type = 'danger';
        } else if(diff < 3) {
            bid.progress_type = 'warning';
        } else {
            bid.progress_type = 'success';
        }

        return bid.bid_request_progress;
    };

    $scope.getProgressType = function(bid) {
        return 'warning';
    };

    $scope.submitBid = function(bid) {
        if(!bid.bid_date_requested) {
            alert('Trade Manager submission date not set');
            return;
        }

        if(bid.task_list.length === 0) {
            alert('Task list is not attached');
            return;
        }

        if(bid.bidding_trades.length === 0) {
            alert('No bidding trades selected');
            return;
        }

        if(!bid.project_type) {
            alert('Select a project type');
            return;
        }

        if(bid.project_type === 'single') {
            if(bid.project_plan.single.length === 0) {
                alert('You must add at least one plan/elevation for a single family project');
                return;
            }
        }

        if(bid.project_type === 'multi' || bid.project_type === 'commercial') {
            if(bid.project_plan.multi.interior.length === 0) {
                alert('You must specify at least one interior plan code');
                return;
            }

            if(bid.project_plan.multi.exterior.length === 0) {
                alert('You must specify at least one exterior plan code');
                return;
            }
        }

        for (var i in $scope.new_bids) {
           if ($scope.new_bids[i] === bid) {
               $scope.new_bids.splice(i, 1);
           }
        }

        bid.bid_status = 'submitted';
        bid.$update();

        for(var j=0; j<bid.bidding_trades.length; j=j+1) {
            NotifyService.addNotification(bid.bidding_trades[j].username, 'toast-info', 'New Bid', 'There is a new bid request for you to fill out and return', 'No');
        }
        $scope.$broadcast('notificationAdded');
        $scope.submitted_bids.push(bid);

        var data = $scope.new_bids;
        $scope.newBidTableParams.total(data.length);
        $scope.newBidTableParams.reload();
    };

    $scope.currentNetPay = function(bid_hours, crew_rate, quantity, piece_rate) {
        var val = 0;

        if(bid_hours > 0) {
            val = bid_hours * crew_rate;
        } else {
            val = quantity * piece_rate;
        }

        return val;
    };

    $scope.directLaborCosts = function(bid_hours, quantity, ali_crew_rate) {
        var val = 0;
        if(bid_hours === 0) {
            val = quantity * ali_crew_rate;
        } else {
            val = bid_hours * ali_crew_rate;
        }

        return val;
    };

    $scope.aliCrewRate = function(bid_hours, piece_rate, crew_rate, ali_crew_net_pay) {
        var val = 0;

        if(bid_hours === 0) {
            val = piece_rate * ali_crew_net_pay;
        } else {
            val = crew_rate * ali_crew_net_pay;
        }

        return val;
    };

    $scope.aliCrewNetPay = function(direct_labor_costs, training_and_education) {
        return direct_labor_costs - training_and_education;
    };

    // $scope.increasePay = function(ali_crew_net_pay, current_net_pay) {
    //     return ali_crew_net_pay - current_net_pay;
    // };

    $scope.hoursAllowed = function(bid_hours, current_net_pay, crew_rate) {
        var temp_value = 0;

        if(!bid_hours) bid_hours = 0;
        if(!current_net_pay) current_net_pay = 0;
        if(!crew_rate) crew_rate = 0;

        if(bid_hours === 0) {
            if(crew_rate)
              temp_value = (current_net_pay / crew_rate);
            else
              temp_value = 0;
        } else {
            temp_value = bid_hours;
        }

        return $filter('number')(temp_value, 2);
    };

    $scope.viewBidBuilderReview = function(index) {
        BidBuilderReview.set($scope.builder_bids[$scope.current_review_bid]);
        //BidBuilderReview.set($scope.my_review_bids[index]);
        $location.path('builder/bids/multi/review');
    };

    $scope.trainingAndEducation = function(hours_allowed, training_and_education) {
        return hours_allowed * training_and_education;
    };

    $scope.employeeBenefits = function(hours_allowed, benefits) {
        return hours_allowed * benefits;
    };

    $scope.applayCalculations = function(tasks) {
        taskTotalsService.getCalculations(tasks, $scope.company_factors);
    };

    $scope.viewBidOldDetails = function() {
        var bid = $filter('filter')($scope.project_bids, {'_id': $scope.details_bid_id}, true);
        if(bid.length !== 1) {
            alert('There is a problem with getting the old bid for review.  Contact Admin!');
            return;
        }
        BidOldReview.set(bid[0]);
        $location.path('builder/bids/old/review');
    };

    $scope.getTradeCode = function(trade) {
        return tradeCodeService.getCode(trade);
    };

    $scope.getTradeString = function(trade) {
        return tradeCodeService.getName(trade);
    };

    $scope.reviseBid = function(id) {
        console.log(id);
        console.log($scope);
        if(!$scope.is_admin) {
            alert('You must have admin rights to delete a bid.');
            return;
        }

        for (var i in $scope.project_bids) {
            if ($scope.project_bids[i]._id === $scope.details_bid_id) {
                var bid = $scope.project_bids.splice(i, 1);
                if(bid.length === 1) {
                    bid[0].bid_status = 'submitted';
                    bid[0].in_bidder_revision = true;
                } else {
                    alert('More than one bid returned for deletion.  Contact Admin.');
                    return;
                }

                var trade = $scope.details_bidding_trades[id];

                TradeBids.query({'_id': trade._id }, function(trade_bid) {
                    if(!trade_bid[0].revisions)
                        trade_bid[0].revisions = [];

                    var number = trade_bid[0].revisions.length + 1;

                    trade_bid[0].revisions.push({
                        number: number,
                        date_completed: new Date(trade_bid[0].date_completed),
                        inclusions: angular.copy(trade_bid[0].inclusions),
                        exclusions: angular.copy(trade_bid[0].exclusions),
                        costs: angular.copy(trade_bid[0].costs),
                        overrides: angular.copy(trade_bid[0].overrides),
                        bid: angular.copy(trade_bid[0].bid)
                    });

                    trade_bid[0].date_completed = new Date();
                    trade_bid[0].in_revision = true;
                    trade_bid[0].accepted = true;
                    trade_bid[0].trade_declined = false;
                    trade_bid[0].first_process = false;
                    trade_bid[0].submitted = 'false';

                    trade_bid[0].$update(function(success) {
                        bid[0].$update(function(success) {
                            success.builder = (success.builder_id) ?
                                success.builder_id.name : $scope.trade.name;

                            $scope.builder_bids.push(success);
                            return;
                        });
                    });
                });
            }
        }
    };

    $scope.reviseBidOperation = function(id) {
        ngDialog.openConfirm({
            template:
                '<h2>Bid Revision Operation</h2>' +
                '<p>This operation will restart the bid process for the selected trade so labor, materials, and/or equipment numbers can be updated by the trade.</p>' +
                '<p>Are you sure you want to revise this bid? </p>' +
                '<div>' +
                  '<button type="button" class="btn btn-default" ng-click="closeThisDialog(0)">No&nbsp;' +
                  '<button type="button" class="btn btn-primary" ng-click="confirm(1)">Yes' +
                '</button></div>',
            plain: true,
            className: 'ngdialog-theme-default'
        }).then(function (value) {
            // perform delete operation
            $scope.reviseBid(id);
        }, function (value) {
            //Do something
            console.log('in the do something section');
        });
    };

    // $scope.setShowPlanDetails =  function(pid) {
    //     $scope.showPlanDetails = pid;
    // };
  }
]);



// WEBPACK FOOTER //
// ./packages/custom/builders/public/controllers/buildersBid.js